module.exports = __webpack_public_path__ + "img/11th_life-skills.6f7dea3b.webp";